const ONE_SECOND_MILISECOND = 1000;
const ONE_MINUTE_MILISECOND = 60 * ONE_SECOND_MILISECOND;
const ONE_HOUR_MILISECOND = 60 * ONE_MINUTE_MILISECOND;
const ONE_DAY_MILISECOND = 24 * ONE_HOUR_MILISECOND;
const ONE_YEAR_MILISECOND = 365 * ONE_DAY_MILISECOND;

export {
  ONE_SECOND_MILISECOND,
  ONE_MINUTE_MILISECOND,
  ONE_HOUR_MILISECOND,
  ONE_DAY_MILISECOND,
  ONE_YEAR_MILISECOND,
}
